export default () => ({
    loading: true,
    foodPoints: null,
    currentFoodPoint: null,
    totalItems: 0
})